import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('village_transport_cost')
export class VillageTransportCostEntity{
    @PrimaryGeneratedColumn('increment', { name : 'village_transport_id'})
    villageTransportCostId:number;

    @Column('varchar',{
        nullable:false,
        length:50,
        name:'village_name',
    })
    villageName:string

    @Column('varchar',{
        nullable:false,
        length:50,
        name:'transport_cost',
    })
    transportCost:number
}